import React, { Component } from "react";
import { Form, Input, Select } from "antd";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps, match } from "react-router-dom";
// import * as _ from 'lodash';

import style from "./list.module.sass";
import {
  addFroms,
  updateForms,
} from "../../../../stateManager/store/forms/action";
import { addStyleUrl, isCoreV3Form } from "../../../../stateManager/store/formCreation_v2/actions"
import { fetchAllStaticAssetsByFiletype } from "../../../../stateManager/store/static-assets/action"
import { Http } from "../../../../helpers/axois";
import { makeFormDupliacte } from "../../../../helpers/RxServices";
import { AppState } from "../../../../stateManager/store";
import { pushToast } from "../../../../stateManager/store/toast/actions";
import { logger } from "../../../../constant/winston";
import { decodeBase64, encodeBase64 } from "../../../../helpers/commonFunction";
import { addAssetInstancesToForm } from "../../forms/formBuilder/helpers";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
  },
};

interface State {
  formName?: string;
  displayName?: string;
  formNameErr?: string;
  displayNameErr?: string;
  themeList?: any[];
  theme?: string;
  themeError?: string;
  styleUrl: string;
}

interface Props {
  onSubmit?: (submit: () => void) => void;
  appId?: any;
  getForms?: () => void;
  addFroms?: (data: any) => void;
  editInitialData?: any;
  editable?: boolean;
  updateForms?: (data: any) => void;
  addStyleUrl?: any
  getSavedForm?: (SavedForm: any) => void;
  match: match<any>;
  appVersion?: { currentVersion: boolean; versionId: string };
  duplicate?: boolean;
  pushToast?: (data: any) => void;
  currentOrgId?: any;
  selectedApp?: any;
  // adding passed version id from form creation page since version gets wrongly set while navigating from that page alone
  versionId?: string;
  loggedInUserId?: any;
  json?: any
  currentBranch?: any;
  fetchAllStaticAssetsByFiletype?:any;
  cssAssets?: any;
  isCoreV3Form?: any;
}

class AppForm extends Component<RouteComponentProps & Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      formName:
        this.props.editInitialData && this.props.editInitialData.formName
          ? this.props.editInitialData.formName
          : "",
      displayName:
        this.props.editInitialData && this.props.editInitialData.displayName
          ? this.props.editInitialData.displayName
          : "",
      formNameErr: "",
      displayNameErr: "",
      themeError: "",
      theme:
        this.props.editInitialData && this.props.editInitialData.themeId
          ? this.props.editInitialData.themeId
          : "",
      styleUrl:
        this.props.editInitialData && this.props.editInitialData.styleUrl
          ? this.props.editInitialData.styleUrl
          : "",
    };
    this.props.onSubmit!(this.onSubmit);
  }

  componentDidMount() {
    this.getThemes();
    this.fetchCSSAssets();
  }

  getThemes = () => {
    Http.get(`org/${this.props.currentOrgId}/themes`).subscribe(
      (res: any) => {
        this.setState({ themeList: res });
      },
      (error) => {
        logger.error("get theme error ===> ", error);
      }
    );
  };

  // Function to fetch CSS assets
  fetchCSSAssets = () => {
    const { appId, currentOrgId, appVersion } = this.props;
    const currentBranchId =
      this.props.currentBranch &&
      this.props.currentBranch[this.props.appId] &&
      this.props.currentBranch[this.props.appId].branchId;
    this.props.fetchAllStaticAssetsByFiletype({
      filetype: "css",
      appId,
      orgId: currentOrgId,
      branchId: currentBranchId,
      versionId: appVersion?.versionId,
    });
  };

  // TO save form json while updating the form custom css
  saveForm = (isCommit: boolean) => {
    const currentBranchId =
      this.props.currentBranch &&
      this.props.currentBranch[this.props.appId] &&
      this.props.currentBranch[this.props.appId].branchId;
    Http.get(`/apps/${this.props.appId}/forms/${this.props.editInitialData.formId}?versionId=${this.props.appVersion && this.props.appVersion.versionId}&branchId=${currentBranchId}`).subscribe((res: any) => {
      if (res.length > 0) {
        const response = res[0]
        if (response.resourceLock.userId === this.props.loggedInUserId) {
          const base64Data = response && response.source;
          const formData = base64Data ? JSON.parse(decodeBase64(base64Data)) : "";
          addAssetInstancesToForm(formData)
          const selectedApp = this.props.selectedApp && this.props.selectedApp || {};
          const appid = this.props.appId && this.props.appId || "";
          const globalCss = selectedApp.find((el: any) => el.appId === appid) ?? '';
          const updatedFormData = {
            ...formData,
            styleUrl: {
              customCssUrl: this.state.styleUrl,
              globalCssUrl: globalCss.globalcss
            },
            coreVersion: 'v3'
          };
          const data = {
            source: encodeBase64(JSON.stringify(updatedFormData)),
            appId: this.props.appId,
            version: this.props.appVersion && this.props.appVersion.versionId,
            branchId: currentBranchId,
            styleUrl: this.state.styleUrl
          }
          Http.put(`/forms/${this.props.editInitialData.formId}?isCommit=${isCommit}`, data).subscribe((formRes) => {
            logger.info("Form saved successfully")
          }, (err) => {
            this.props.pushToast && this.props.pushToast(
              { type: 'error', message: 'Error while saving form' }
            )
          }
          )
        }
      }
    })
  }

  onSubmit = () => {
    const currentBranchId =
      this.props.currentBranch &&
      this.props.currentBranch[this.props.appId] &&
      this.props.currentBranch[this.props.appId].branchId;
    let shouldModalClose = true;
    if (this.state.formName && this.state.theme && this.state.displayName) {
      let { editable, editInitialData, duplicate } = this.props;
      if (duplicate) {
        makeFormDupliacte.sendMessage({
          from: "duplicate",
          formName: this.state.formName,
          theme: this.state.theme,
          branchId: currentBranchId,
          displayName:this.state.displayName
        });
      } else {
        if (!editable) {
          this.saveForms();
        } else if (editInitialData) {
          this.updateForms(editInitialData.formId);
        }
      }
    } else {
      const error: any = {};
      if (!this.state.theme) error["themeError"] = "required";
      if (!this.state.formName) error["formNameErr"] = "required";
      if (!this.state.displayName) error["displayNameErr"] = "required";
      this.setState(error);
      shouldModalClose = false;
    }
    return shouldModalClose;
  };

  checkout = (props:any) => {
    const {app_id , version_id, form_id} = props;
    Http.post(`forms/${form_id}/checkout`, {
      appId: app_id,
      versionId: version_id
    }).subscribe(() => {
    }, (err) => {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : "Form checkout failed" }
      )
    })
  }

  saveForms () {
    const currentBranchId =
      this.props.currentBranch &&
      this.props.currentBranch[this.props.appId] &&
      this.props.currentBranch[this.props.appId].branchId;
    const data = {
      name: this.state.formName,
      displayName: this.state.displayName,
      appId: this.props.appId,
      themeId: this.state.theme,
      version: this.props.appVersion && this.props.appVersion.versionId,
      branchId: currentBranchId,
      isV2: true,
      styleUrl: this.state.styleUrl ? this.state.styleUrl : "",
      coreVersion: 'v3'
    }
    Http.post('forms', data).subscribe((formRes:any) => {
      const data = {
        customCssUrl: this.state.styleUrl
      }
      const response = formRes && formRes.length > 0 && formRes[0]
      if (response && response?.app_id && response?.version_id && response?.form_id) {
        const {app_id, version_id, form_id} = response;
        this.checkout({app_id , version_id, form_id})
      }
      this.props.addStyleUrl(data)
      if (response.core_version === "v3") {
        this.props.isCoreV3Form(true)
      } else {
        this.props.isCoreV3Form(false)
      }
      this.props.pushToast && this.props.pushToast(
        { type: 'success', message: 'Form saved successfully' }
      )
      this.props.getSavedForm && this.props.getSavedForm(formRes);
      this.props.getForms && this.props.getForms();
    }, (err) => {
      this.props.pushToast && this.props.pushToast(
        { type: 'error', message: (err && err.message) ? err.message : "Form save failed" }
      )
    })

  }

  updateForms(formId?: string) {
    const currentBranchId =
      this.props.currentBranch &&
      this.props.currentBranch[this.props.appId] &&
      this.props.currentBranch[this.props.appId].branchId;
    const data: any = {
      name: this.state.formName,
      displayName: this.state.displayName,
      appId: this.props.appId,
      themeId: this.state.theme,
      version: this.props.versionId ? this.props.versionId : this.props.appVersion && this.props.appVersion.versionId,
      branchId: currentBranchId,
      isV2: true,
      styleUrl: this.state.styleUrl
    }

    Http.put(`/forms/${formId}`, data).subscribe(
      (formRes) => {
        const data = {
          customCssUrl: this.state.styleUrl
        }
        this.props.addStyleUrl(data)
        this.props.pushToast &&
          this.props.pushToast({
            type: "success",
            message: "Form updated successfully",
          });
        this.saveForm(false)
        this.props.getForms && this.props.getForms();
      },
      (err) => {
        this.props.pushToast &&
          this.props.pushToast({
            type: "error",
            message: err && err.message ? err.message : "Form updation failed",
          });
      }
    );
  }

  render() {
    let { editInitialData } = this.props;
    let { formNameErr, themeError, displayNameErr } = this.state;
    const { cssAssets } = this.props;
    const cssAssetOptions = Object.values(cssAssets).map((asset: any) => {
      if (asset.url) {
        return (
          <Option key={asset.id} value={asset.url}>
            {asset.filename}
          </Option>
        )
      }
    });
    return (
      <div>
        <Form {...formItemLayout} className={style.app + " override-content"}>
          <Form.Item
            validateStatus={displayNameErr && "error"}
            help={displayNameErr}
            label={<span className={style.labelName}>Display Name</span>}
          >
            <Input
              data-test-id="display_name"
              defaultValue={editInitialData && editInitialData.displayName}
              value={this.state.displayName}
              onChange={(e) => {
                const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;
                if (e.target.value === "" || re.test(e.target.value)) {
                  let val = e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "");
                  let value = val.replace(/ /g, "_");
                  this.setState({
                    displayName: e.target.value,
                    formName: editInitialData ? this.state.formName:value,
                    displayNameErr: "",
                  });
                }
              }}
            />
          </Form.Item>
          <Form.Item
            validateStatus={formNameErr && "error"}
            help={formNameErr}
            label={<span className={style.labelName}>Name(identifier)</span>}
          >
            <Input
              data-test-id="form_name"
              disabled={editInitialData}
              defaultValue={editInitialData && editInitialData.formName}
              value={this.state.formName}
              onChange={(e) => {
                const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
                if (e.target.value === "" || re.test(e.target.value)) {
                  this.setState({
                    formName: e.target.value.trim().replace(/ /g, "_"),
                    formNameErr: "",
                  });
                }
              }}
            />
          </Form.Item>
          <Form.Item
            validateStatus={themeError && "error"}
            help={themeError}
            label={<span className={style.labelName}>Theme</span>}
          >
            <Select
              style={{ width: "100%" }}
              data-test-id="form_theme"
              defaultValue={editInitialData && editInitialData.themeId}
              onChange={(e: any) => this.setState({ theme: e, themeError: "" })}
            >
              {this.state.themeList &&
                this.state.themeList.map((d, index) => (
                  <Option
                    data-test-id={`theme_${d.theme_name}`}
                    key={index}
                    value={d.theme_id}
                  >
                    {d.theme_name}{" "}
                    <small>({d.is_system ? "system" : "custom"})</small>
                  </Option>
                ))}
            </Select>
          </Form.Item>
          <Form.Item label={<span className={style.labelName}>Custom css</span>}>
            <Select
              data-test-id="form_css"
              style={{ width: "100%" }}
              defaultValue={editInitialData && editInitialData.styleUrl}
              onChange={(value) => {
                return (
                  this.setState({ styleUrl: value })
                )
              }
              }
            >
              <Option key="empty" value="empty">
                Custom (empty)
              </Option>
              {cssAssetOptions}
            </Select>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state: AppState, props: Props) => {
  const params: any = props.match.params;
  return {
    appId: state.apps.selectedApp.id,
    appVersion: state.apps.appVersion[params["appId"]],
    currentOrgId: state.org.selectedOrg!.id,
    currentBranch: state.apps.appBranch,
    selectedApp: state.apps.appsList,
    loggedInUserId: state.user.data.user.id,
    cssAssets: state.staticAssets.css,
  };
};

export default withRouter(
  connect(mapStateToProps, { addFroms, updateForms, pushToast, addStyleUrl, fetchAllStaticAssetsByFiletype, isCoreV3Form })(AppForm)
);
